import React, { useState, useEffect } from "react";

import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Card,
  CardContent,
  CardActionArea,
} from "@material-ui/core";

import { connect } from "react-redux";
import Loading from "../../Loading";
import { getPendingToDeliver } from "../../../actions/sellerActions";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";

const OrdersToDeliver = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (props.auth.isAuthenticated) {
      props.getPendingToDeliver(props.auth.seller._id);
    }
  }, [props.auth.isAuthenticated]);

  useEffect(() => {
    if (props.deliveryPendingOrders) {
      setData(props.deliveryPendingOrders);
      setLoading(false);
    }
  }, [props.deliveryPendingOrders]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <div
        style={{
          backgroundColor: "chocolate",
          color: "white",
          padding: "1px 0 1px 30px",
          margin: "10px 0",
          borderRadius: "10px",
        }}
      >
        <div style={{ display: "flex",alignItems:'center' }}>
          <HourglassEmptyIcon
            style={{
              height: 30,
              width: 30,
              marginRight: 10,
            }}
          />
          <h3>Pending To Deliver</h3>
        </div>
      </div>
      {!loading && (data.length === 0 || !data) ? (
        <div style={{ display: "flex" }}>
          <HourglassEmptyIcon style={{ margin: "20px 20px 20px 0" }} />
          <h3>No Pending Order To Deliver</h3>
        </div>
      ) : (
        <Grid container spacing={2}>
          {data.map((Order, index) => {
            const { buyer, order, location, address, _id } = Order;
            return (
              <Grid item xs={12} md={6} lg={4} key={index}>
                <Card variant="outlined">
                  <CardActionArea>
                    <CardContent
                      style={{ padding: "10px 0", backgroundColor: "bisque" }}
                    >
                      <>
                        <Typography
                          variant="h6"
                          style={{ marginLeft: "15px", color: "black" }}
                        >
                          {buyer.name}
                        </Typography>
                        <div>
                          <Table className="table">
                            <TableHead>
                              <TableRow>
                                <TableCell></TableCell>
                                <TableCell className="bigDevices">
                                  <b>Items</b>
                                </TableCell>
                                <TableCell numeric>
                                  <b>Quantity</b>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            {order.map((arder, i) => {
                              const { item, quantity } = arder;
                              return (
                                <TableBody key={i}>
                                  <TableRow>
                                    <TableCell>
                                      <img
                                        src={item.images[0]}
                                        style={{
                                          width: "75px",
                                          borderRadius: "13%",
                                        }}
                                        alt="ItemImage"
                                      />
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      className="bigDevices"
                                    >
                                      {item.name}
                                    </TableCell>
                                    <TableCell numeric>{quantity}</TableCell>
                                  </TableRow>
                                </TableBody>
                              );
                            })}
                          </Table>
                        </div>
                        <p style={{ textAlign: "center", color: "black" }}>
                          <b>Address:</b> {address}
                        </p>
                      </>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  deliveryPendingOrders: state.server.deliveryPendingOrders,
});

export default connect(mapStateToProps, { getPendingToDeliver })(
  OrdersToDeliver
);
